import connect from '../axios/axios.auth';

const functions = {
    ajustar: (data) => {
        return new Promise((resolve, reject) => {
            connect.post(`/boletas/actualizar/`, data)
            .then((response) => {
                resolve(response.data);
            })
        })
    },
    registrar: (data) => {
        return new Promise((resolve, reject) => {
          connect.post(`/boletas/registrar/`, data)
          .then((response) => {
            resolve(response.data);
          })
        })
    },
    listado: (typeDocument) => {
        return new Promise((resolve, reject) => {
            connect.get(`/boletas/${typeDocument}`)
            .then((response) => {
                resolve(response.data);
            })
         }) 
    },
    detalle: (boletaId) => {
        return new Promise((resolve, reject) => {
            connect.get(`/boletas/detalle/${boletaId}/`)
            .then((response) => {
                resolve(response.data);
            })
         }) 
    },
    anular: (data) => {
        return new Promise((resolve, reject) => {
            connect.post(`/boletas/anular/`, data)
            .then((response) => {
                resolve(response.data);
            })
         }) 
    },
    mail: (data) => {
        return new Promise((resolve, reject) => {
            connect.post(`/boletas/mail/`, data)
            .then((response) => {
                resolve(response.data);
            })
        }) 
    }
}

export default functions;